import { ca } from '@cian/analytics';

import { IProduct } from '../../../types/analytics';

interface ITrackCallParams {
  label: string;
  product: IProduct;
}

export function trackCall({ label, product }: ITrackCallParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Call_listing',
    label,
    products: [product],
  });
}
